import { MongoObservable } from 'meteor-rxjs';
import { LogEntry } from '../models/logEntry';

export const UserLogs = new MongoObservable.Collection<LogEntry>('userlogs');

if (Meteor.isServer) {
  UserLogs.rawCollection().createIndex({ inviteeId: 1 });
  UserLogs.rawCollection().createIndex({ timestamp: 1 });
  UserLogs.rawCollection().createIndex({ userId: 1 });
}
